import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { TrendingUp, Menu, X } from 'lucide-react';

const PublicHeader = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    return (
        <nav className="border-b border-slate-800/50 bg-slate-900/80 backdrop-blur-xl sticky top-0 z-50 shadow-lg shadow-black/20">
            <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center h-16 sm:h-20">
                    <Link to="/" className="flex items-center gap-2 sm:gap-3 text-lg sm:text-2xl font-bold">
                        <div className="bg-gradient-to-br from-blue-500 to-purple-600 p-1.5 sm:p-2 rounded-lg sm:rounded-xl">
                            <TrendingUp className="text-white" size={24} />
                        </div>
                        <span className="bg-gradient-to-r from-blue-400 via-purple-400 to-pink-400 bg-clip-text text-transparent">
                            Albatech
                        </span>
                    </Link>

                    <div className="hidden md:flex items-center gap-8">
                        <Link to="/" className="text-gray-300 hover:text-white transition font-medium">Home</Link>
                        <a href="/#markets" className="text-gray-300 hover:text-white transition font-medium">Markets</a>
                        <a href="/#features" className="text-gray-300 hover:text-white transition font-medium">Features</a>
                        <a href="/#about" className="text-gray-300 hover:text-white transition font-medium">About</a>
                    </div>

                    <div className="hidden md:flex items-center gap-4">
                        <Link
                            to="/login"
                            className="text-gray-300 hover:text-white transition px-6 py-2.5 font-medium"
                        >
                            Sign In
                        </Link>
                        <Link
                            to="/register"
                            className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-6 py-2.5 rounded-xl hover:from-blue-700 hover:to-purple-700 transition font-semibold shadow-lg shadow-blue-500/30"
                        >
                            Get Started
                        </Link>
                    </div>

                    {/* Mobile Menu Button */}
                    <div className="md:hidden">
                        <button
                            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                            className="text-gray-300 hover:text-white p-2"
                        >
                            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
                        </button>
                    </div>
                </div>
            </div>

            {/* Mobile Menu */}
            {isMobileMenuOpen && (
                <div className="md:hidden bg-slate-900 border-b border-slate-800 animate-fade-in">
                    <div className="px-4 pt-2 pb-6 space-y-4">
                        <Link to="/" className="block text-gray-300 hover:text-white py-2 font-medium" onClick={() => setIsMobileMenuOpen(false)}>Home</Link>
                        <a href="/#markets" className="block text-gray-300 hover:text-white py-2 font-medium" onClick={() => setIsMobileMenuOpen(false)}>Markets</a>
                        <a href="/#features" className="block text-gray-300 hover:text-white py-2 font-medium" onClick={() => setIsMobileMenuOpen(false)}>Features</a>
                        <a href="/#about" className="block text-gray-300 hover:text-white py-2 font-medium" onClick={() => setIsMobileMenuOpen(false)}>About</a>
                        <div className="pt-4 flex flex-col gap-3">
                            <Link
                                to="/login"
                                className="block text-center text-gray-300 hover:text-white py-2.5 font-medium border border-slate-700 rounded-xl"
                                onClick={() => setIsMobileMenuOpen(false)}
                            >
                                Sign In
                            </Link>
                            <Link
                                to="/register"
                                className="block text-center bg-gradient-to-r from-blue-600 to-purple-600 text-white py-2.5 rounded-xl font-semibold shadow-lg shadow-blue-500/30"
                                onClick={() => setIsMobileMenuOpen(false)}
                            >
                                Get Started
                            </Link>
                        </div>
                    </div>
                </div>
            )}
        </nav>
    );
};

export default PublicHeader;
